module.exports = new __parcel__URL__("neon_gold_icon.48f69ef3.png").toString();